
import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ProducerNameDisplayProps {
  producerId?: string;
  producerName?: string;
}

export const ProducerNameDisplay: React.FC<ProducerNameDisplayProps> = ({ 
  producerId, 
  producerName 
}) => {
  const [displayName, setDisplayName] = useState<string>(
    // If it doesn't look like a UUID, use it directly
    producerName && !producerName.includes('-') 
      ? producerName 
      : 'Loading...'
  );

  useEffect(() => {
    // If we already have a display name that's not a UUID, use it
    if (displayName !== 'Loading...') return;

    const fetchProducerName = async () => {
      // ID to look up - prefer producerId if available, otherwise use producerName if it looks like a UUID
      const lookupId = producerId || (producerName && producerName.includes('-') ? producerName : null);
      
      if (!lookupId) {
        setDisplayName('Unknown Producer');
        return;
      }

      try {
        const { data: producerData, error } = await supabase
          .from('profiles')
          .select('first_name, last_name')
          .eq('id', lookupId)
          .single();
        
        if (error || !producerData) {
          setDisplayName(`Producer ${lookupId.substring(0, 5)}`);
          return;
        }
        
        setDisplayName(`${producerData.first_name} ${producerData.last_name}`);
      } catch (err) {
        console.error('Error fetching producer name:', err);
        setDisplayName(`Producer ${lookupId.substring(0, 5)}`);
      }
    };

    fetchProducerName();
  }, [producerId, producerName, displayName]);

  return <span>{displayName}</span>;
};
